<template>
  <div class="flex items-center justify-between w-full">
    <slot />
    <div class="border-solid border-2 h-px w-full ml-4 mr-6" />
  </div>
</template>
